import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonComponent } from 'src/app/ui/button/button.component';
import { Subject, takeUntil } from 'rxjs';
import { AccountService } from '../../services/account.service';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { ISmartInboxState, ISmartInboxStateType } from '../../models/inbox.models';

@Component({
  selector: 'app-inbox-welcome',
  standalone: true,
  imports: [ButtonComponent, SvgIconComponent, TranslateModule],
  templateUrl: './inbox-welcome.component.html',
  styleUrls: ['./inbox-welcome.component.scss'],
})
export class InboxWelcomeComponent {
  @Output() onConnect = new EventEmitter<void>();
  @Output() onError = new EventEmitter<ISmartInboxStateType>();

  isLoading = false;

  private destroy$ = new Subject<void>();

  constructor(private accountService: AccountService) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initializeConnectionWizard(): void {
    this.isLoading = true;
    this.accountService
      .openConnectionWizard()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (success) => {
          this.isLoading = false;
          if (success) {
            this.onConnect.emit();
          } else {
            this.onError.emit(ISmartInboxState.CONNECTION_ERROR);
          }
        },
        error: (err) => {
          this.onError.emit(ISmartInboxState.SERVICE_ERROR);
          console.error('Error initializing connection wizard:', err);
          this.isLoading = false;
        },
      });
  }
}
